import React from "react";
import ReactDOM from "react-dom";

const body = typeof document !== "undefined" ? document.body : null;

class Portal extends React.Component {
  constructor(props) {
    super(props);

    this.element =
      typeof document !== "undefined" ? document.createElement("div") : null;
  }

  componentDidMount() {
    if (body) {
      body.appendChild(this.element);
    }
  }

  componentWillUnmount() {
    if (body) {
      body.removeChild(this.element);
    }
  }

  render() {
    const { children } = this.props;

    if (this.element) {
      return ReactDOM.createPortal(children, this.element);
    }

    return null;
  }
}

export default Portal;
